import {
  Box,
  Button,
  Divider,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';

import { AppColors } from '../utils/utils';
import { Link as RouterLink, NavLink } from 'react-router-dom';
import { navItems } from './Header';

const Footer: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // e.g. <600px

  return (
    <>
      <Box
        sx={{
          background: `url('/static/images/img_knocard_auto_footer.png')`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          px: { xs: 5, sm: 5, md: 20, lg: 40 },
          py: 2,
        }}
      >
        <Stack
          direction={isMobile ? 'column' : 'row'}
          spacing={isMobile ? 1 : 2}
          justifyContent='space-between'
          alignItems='center'
          color='white'
          fontSize={isMobile ? '10px' : '14px'}
          textAlign='center'
        >
          {/* Logo */}
          <Box
            component={RouterLink}
            to='/'
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <Box
              component='img'
              src='/static/images/knocard_ai_logo_white.png'
              alt='KnoCard Auto Logo'
              sx={{ height: 40 }}
            />
          </Box>

          <Stack direction={isMobile ? 'column' : 'row'} spacing={1}>
            {navItems.map((item) => (
              <Button
                key={item.label}
                component={NavLink}
                to={item.path}
                sx={{
                  color: 'white',
                  textTransform: 'none',
                  '&.active': {
                    fontWeight: 'bold',
                  },
                }}
              >
                {item.label}
              </Button>
            ))}

            <Button
              component={NavLink}
              to='mailto:support@knocard.com'
              //   href='mailto:support@knocard.com'
              target='_blank'
              //   underline='none'
              sx={{ color: 'white', textTransform: 'none' }}
            >
              support@knocard.com
            </Button>
          </Stack>
        </Stack>

        <Divider sx={{ background: '#EAEEF5', my: 2, width: 1 }} />

        <Stack
          direction={isMobile ? 'column' : 'row'}
          spacing={isMobile ? 1 : 2}
          justifyContent='center'
          alignItems='center'
          color='white'
          fontSize={isMobile ? '10px' : '14px'}
          textAlign='center'
          sx={{
            px: 1,
          }}
        >
          <Stack direction={'row'} spacing={isMobile ? 1 : 2}>
            <Typography fontSize={'inherit'}>
              {`Copyright ${new Date().getFullYear()} KnoCard ©`}
            </Typography>

            <Typography variant='body2'>|</Typography>

            <Typography fontSize={'inherit'}>All Rights Reserved</Typography>

            {!isMobile && <Typography variant='body2'>|</Typography>}
          </Stack>

          <Stack direction={'row'} spacing={isMobile ? 1 : 2}>
            <Link
              href='https://knocard.com/termsofuse'
              target='_blank'
              underline='none'
              sx={{ color: AppColors.whiteColor }}
            >
              <Typography fontSize={'inherit'}>Terms of Use</Typography>
            </Link>

            <Typography variant='body2'>|</Typography>

            <Link
              href='https://knocard.com/privacypolicy'
              target='_blank'
              underline='none'
              sx={{ color: AppColors.whiteColor }}
            >
              <Typography fontSize={'inherit'}>Privacy Policy</Typography>
            </Link>
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default Footer;
